import React, { useState } from 'react';
import { joinClasses } from '../../Utils/className.util';
import SignatureCanvas from 'react-signature-canvas';
import LinkButton from '../Button/LinkButton';
import apiClient from '../../Services/ApiClient';
import Loading from '../Loading';
import FirstUpper from '../FirstUpper';
import TextField from '../Base/TextField/TextField';
import Button from '../Button/Button';
import { useEffectAsync } from '../../helpers';
import useTranslation from '../../Hooks/useTranslation';
// @ts-ignore
import styles from './SignatureModalContent.module.scss';
import useApiClient from '../../Modules/Base/Hooks/useApiClient';
import { useUserEmailQuery } from '../../graphql/graphql';

interface SignatureModalContentProps {
	userId: string;
}

export default function SignatureModalContent(
	props: SignatureModalContentProps,
) {
	const { userId } = props;
	const [activeTab, setActiveTab] = useState('current');
	const [sigCanvas, setSigCanvas] = useState(null);
	const [imageData, setImageData] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [uploadPreview, setUploadPreview] = useState(null);
	const { t } = useTranslation();
	const [unlocked, setUnlocked] = useState(false);
	const [loading, setLoading] = useState(false);
	const [tempPassword, setTempPassword] = useState('');
	const [verifyError, setVerifyError] = useState('');
	const [signatureData, setSignatureData] = useState(null);
	const { displayError } = useApiClient();

	const { data, isLoading } = useUserEmailQuery({ id: userId });

	const handleChangeActiveTab = tab => {
		setActiveTab(tab);
	};

	// @ts-ignore
	const loadSignature = async () => {
		try {
			setImageData(null);
			const data = await apiClient.get('/doctors/' + userId + '/signature', {
				responseType: 'blob',
				catchError: false,
			});
			if (data.status === 200) {
				const reader = new FileReader();
				reader.onloadend = function () {
					setImageData(reader.result);
				};
				reader.readAsDataURL(data.data);
			} else {
				setImageData(false);
			}
		} catch (e) {
			setImageData(false);
		}
	};

	const handleSaveDraw = () => {
		const canvas = sigCanvas.getTrimmedCanvas();
		// @ts-ignore
		canvas.toBlob(async blob => {
			// save
			const formData = new FormData();
			formData.append('files[]', blob);
			await apiClient.postMultipart(
				'/doctors/' + userId + '/signature',
				formData,
			);

			// preview
			// await loadSignature(); // pokud to tam dam ihned, s3 ještě vrací 404, musí se chvíli počkat, tak to ojebem fejkem
			setImageData(canvas.toDataURL('image/png'));
			setActiveTab('current');
		}, 'image/png');
	};

	// @ts-ignore
	const handleUploadFile = async event => {
		setSelectedFile(event ? event.target.files && event.target.files[0] : null);
		setUploadPreview(
			event
				? event.target.files && URL.createObjectURL(event.target.files[0])
				: null,
		);

		// const formData = new FormData();
		// formData.append('files[]', selectedFile);
		// await apiClient.postMultipart('/some-url', formData)
	};

	// @ts-ignore
	const handleVerifyPassword = async () => {
		setLoading(true);
		setVerifyError('');

		try {
			if (data?.user?.email) {
				const auth = await apiClient.post('/authentication', {
					username: data.user.email,
					password: tempPassword,
				});
				if (auth.data.token) {
					setUnlocked(true);
					await loadSignature();
				}
			}
		} catch (error: any) {
			setVerifyError(error.response.data.message);
		} finally {
			setLoading(false);
		}
	};

	// @ts-ignore
	useEffectAsync(async () => {
		if (!signatureData) {
			const response = await apiClient.get(
				'/doctors/' + userId + '/signature-text',
			);
			setSignatureData(response.data);
		}
		// if(selectedFile) {
		//     setUploadPreview(URL.createObjectURL(selectedFile));
		//     const element = document.getElementById('uploadSignaturePreview');
		//     const canvas = document.createElement('canvas');
		//     const context = canvas.getContext('2d');
		//     context.drawImage(element, 0, 0 );
		//     const imageData = context.getImageData(0, 0, element.width, element.height);
		//     imageThreshold(imageData, { threshold: 30 }, 4)
		//         .then(function (result) {
		//             console.log(result);
		//             setUploadPreview(imageFilterCore.convertImageDataToCanvasURL(result));
		//         });
		// } else {
		//     setUploadPreview(null);
		// }
	});

	if (isLoading) {
		return <Loading />;
	}

	if (!unlocked) {
		return (
			<div>
				{loading && (
					<div className={'py-4'}>
						<Loading />
					</div>
				)}
				{!loading && (
					<>
						{verifyError && (
							<p className={'text-danger font-weight-bold'}>{verifyError}</p>
						)}
						<p>
							<FirstUpper>{t('component.signature.needVerify')}</FirstUpper>
						</p>
						<p>
							<FirstUpper>
								{t('component.signature.needVerify2') || ''}
							</FirstUpper>
						</p>
						<TextField
							type={'password'}
							name={'password'}
							onChange={setTempPassword}
							placeholder={t('component.signature.enterYourMeddiPassword')}
						/>
						<Button
							onClick={handleVerifyPassword}
							title={t('component.signature.verifyPassword')}
							theme={'green'}
							className={'mt-3'}
						/>
					</>
				)}
			</div>
		);
	}

	return (
		<div>
			<div className={styles.tabControlWrapper}>
				<div className={styles.primaryControls}>
					<div
						className={joinClasses([
							styles.tabButton,
							activeTab === 'current' && styles.tabButtonActive,
						])}
						onClick={() => handleChangeActiveTab('current')}>
						<FirstUpper>{t('component.signature.actual')}</FirstUpper>
					</div>
					<div
						className={joinClasses([
							styles.tabButton,
							activeTab === 'draw' && styles.tabButtonActive,
						])}
						onClick={() => handleChangeActiveTab('draw')}>
						<FirstUpper>{t('component.signature.sign')}</FirstUpper>
					</div>
					{/*<div className={joinClasses([styles.tabButton, activeTab === 'upload' && styles.tabButtonActive])}*/}
					{/*    onClick={() => handleChangeActiveTab('upload')}><FirstUpper>{t('component.signature.upload')}</FirstUpper></div>*/}
				</div>
			</div>
			{activeTab === 'current' && (
				<div className={joinClasses([styles.textTab, styles.tab])}>
					{imageData === null && (
						<div className={'py-5'}>
							<Loading />
						</div>
					)}
					<div className={styles.signature}>
						<div className={styles.image}>
							{imageData === false && (
								<>{t('component.signature.noSignature')}</>
							)}
							{imageData && <img src={imageData} alt={'current signature'} />}
						</div>
						<div className={styles.text}>
							{signatureData && (
								<>
									{signatureData.fullName}
									<br />
									{signatureData.identificationDocument?.type && (
										<>
											{signatureData.identificationDocument.type}:{' '}
											{signatureData.identificationDocument.number}
											<br />
										</>
									)}
									<br />
									<FirstUpper>
										{t('component.signature.electronicallyGenerated')}
									</FirstUpper>
									<br />
									<FirstUpper>
										{t('component.signature.place')}
									</FirstUpper>: {signatureData.address}
									<br />
									<FirstUpper>{t('component.signature.date')}</FirstUpper>:
									{signatureData.date}
									<br />
									<FirstUpper>{t('component.signature.time')}</FirstUpper>:
									{signatureData.time} {t('component.signature.hours')}
								</>
							)}
						</div>
					</div>
				</div>
			)}
			{activeTab === 'draw' && (
				<div className={joinClasses([styles.tab, styles.textTabWithCanvas])}>
					<p>
						<FirstUpper>{t('component.signature.drawDescription')}</FirstUpper>
					</p>
					<SignatureCanvas
						SpenColor='black'
						canvasProps={{
							width: 552,
							height: 300,
							className: styles.sigCanvas,
						}}
						ref={ref => {
							setSigCanvas(ref);
						}}
					/>
					<div className={styles.controls}>
						<LinkButton
							onClick={() => {
								sigCanvas.clear();
							}}
							title={t('component.signature.startAgain')}
							theme={'red'}
						/>
						<Button
							onClick={handleSaveDraw}
							title={t('base.shared.save')}
							theme={'blue'}
							className={''}
						/>
					</div>
				</div>
			)}
			{activeTab === 'upload' && (
				<div className={joinClasses([styles.textTab, styles.tab])}>
					{selectedFile && (
						<>
							<img
								src={uploadPreview}
								alt={'current upload'}
								className={styles.uploadPreview}
								id={'uploadSignaturePreview'}
							/>
							<LinkButton
								onClick={() => {
									setSelectedFile(null);
								}}
								title={t('component.signature.startAgain')}
								theme={'red'}
							/>
						</>
					)}
					{!selectedFile && (
						<input
							accept='image/*'
							type={'file'}
							name={'signatureUpload'}
							onChange={handleUploadFile}
						/>
					)}
				</div>
			)}
		</div>
	);
}
